// Shared low-poly estate props — tiny freight dressing (a strapped cargo crate
// and a mooring bollard) that stand on ANY raised surface, not just the
// standard foundation top. Ported from age-of-mcp's v2/estate-parts.ts: the
// pure geometry is kept verbatim, with the Part type taken from the library.
// Unlike props.ts's crate/barrel — which are pinned to the foundation top —
// these take a `baseY` so a deck, quay or hook can be dressed at its own
// height.

import * as THREE from "three";
import type { Part } from "../types";

const STRAP = "#6b4a26";

/** A strapped timber cargo crate standing on a surface whose top is `baseY`. */
export function cargoCrate(
  x: number, baseY: number, z: number, s = 0.24, color = "#9a7440",
): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(s, s, s), color, position: [x, baseY + s / 2, z] },
    // A slightly proud band around the middle reads as the shipping strap.
    { geometry: new THREE.BoxGeometry(s * 1.06, s * 0.16, s * 1.06), color: STRAP,
      position: [x, baseY + s / 2, z] },
  ];
}

/** A squat cast bollard (mooring post / vehicle bumper) on a surface top `baseY`. */
export function bollard(
  x: number, baseY: number, z: number, h = 0.16, color = "#3f3b35",
): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.045, 0.055, h, 6), color,
      position: [x, baseY + h / 2, z] },
    { geometry: new THREE.CylinderGeometry(0.06, 0.05, 0.045, 6), color,
      position: [x, baseY + h + 0.02, z] },
  ];
}
